var map = {
	"./black/quxiaojingyin.png": "iFsl",
	"./blue/quxiaojingyin.png": "nR42",
	"./white/quxiaojingyin.png": "8ZlW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af72";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/quxiaojingyin\.png$
// module id = af72
// module chunks = 24